module.exports = __webpack_public_path__ + "static/media/MANEJO_CAJA.9ec262c2.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/archivos/MANEJO_CAJA.pdf
// module id = 76
// module chunks = 0